import {Box, Card, Grid, Stack, Typography} from "@mui/joy";
import React from "react";
import {motion} from "motion/react";
import {Award, BookOpen, Sparkles, Target} from "lucide-react";
import {gradientPairs} from "../../theme";
import GuestNavbar from "../../components/Layout/GuestNavbar";
import {useTranslation} from "react-i18next";

const VALUES = [
    {
        title: "aboutFeatures1Title",
        description: "aboutFeatures1Description",
        icon: Award,
        gradient: gradientPairs[0],
    },
    {
        title: "aboutFeatures2Title",
        description: "aboutFeatures2Description",
        icon: Target,
        gradient: gradientPairs[1],
    },
    {
        title: "aboutFeatures3Title",
        description: "aboutFeatures3Description",
        icon: BookOpen,
        gradient: gradientPairs[2],
    },
    {
        title: "aboutFeatures4Title",
        description: "aboutFeatures4Description",
        icon: Sparkles,
        gradient: gradientPairs[3],
    }
]

const About = () => {
    const {t} = useTranslation()
    return (
        <Stack sx={{minHeight: "100vh", overflowX: "hidden"}}>
            <GuestNavbar active="about"/>

            <Stack
                paddingX={{xs: 2, sm: 4, lg: 6}}
                paddingY={{xs: 4, md: 6}}
                gap={5}
                alignItems="center">
                <motion.div
                    initial={{opacity: 0, y: 16}}
                    animate={{opacity: 1, y: 0}}
                    transition={{duration: 0.4}}
                    style={{textAlign: "center", maxWidth: 640}}>
                    <Typography
                        level="h1"
                        sx={{fontSize: {xs: "1.75rem", md: "2.25rem"}, marginBottom: 1}}>
                        {t("aboutPageTitle")}
                    </Typography>
                    <Typography level="body-lg" textColor="neutral.600">
                        {t("aboutPageDescription")}
                    </Typography>
                </motion.div>

                <Card
                    variant="soft"
                    sx={{
                        maxWidth: "40rem",
                        width: "100%",
                        padding: 3,
                        borderRadius: 15,
                    }}
                    data-no-glow
                    data-no-animation
                >
                    <Typography level="title-lg" sx={{marginBottom: 2}}>
                        {t("ourMissionTitle")}
                    </Typography>
                    <Typography level="body-md" textColor="neutral.600">
                        {t("ourMissionDescription")}
                    </Typography>
                </Card>

                <Stack gap={3}>
                    <Typography
                        level="h2" textAlign={"center"}>
                        {t("whatWeStandForTitle")}
                    </Typography>
                    <Grid container spacing={2.5}>
                        {VALUES.map((item, i) => (
                            <Grid xs={12} sm={6} key={item.title}>
                                <motion.div
                                    initial={{opacity: 0, y: 16}}
                                    animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.4, delay: i * 0.08}}
                                >
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            padding: 3,
                                            height: "100%",
                                        }}
                                        data-no-glow
                                        data-no-animation
                                    >

                                        <Box
                                            sx={{
                                                padding: 2,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                alignSelf: "center",
                                                borderRadius: 10,
                                                background: `linear-gradient(to bottom right, ${item.gradient[0]}, ${item.gradient[1]})`,
                                            }}
                                        >
                                            <item.icon size={22} style={{color: "white", fontSize: 40}}/>
                                        </Box>
                                        <Stack gap={1} alignItems={"center"}>
                                            <Typography level="title-lg">{t(item.title)}</Typography>
                                            <Typography level="body-sm" textAlign={"center"} textColor="neutral.600">
                                                {t(item.description)}
                                            </Typography>
                                        </Stack>
                                    </Card>
                                </motion.div>
                            </Grid>
                        ))}
                    </Grid>
                </Stack>
            </Stack>
        </Stack>
    );
};

export default About;
